import { FoundationsEnums } from '../../enum'
import Highcharts from 'highcharts'
import { Options } from 'highcharts'
import { Chart, Class } from 'highcharts'
import { FoundationsRequest, getBaseUrl, isOperationAllowed } from '../../Utils'

declare let window: any

export const getChartDisplayTypeForViewerType = function (
    viewerType: FoundationsEnums.VisualUnitViewerType
) {
    let chartDisplayType = 'bar'
    if (viewerType == FoundationsEnums.VisualUnitViewerType.Chart_Pie) {
        chartDisplayType = 'pie'
    } else if (viewerType == FoundationsEnums.VisualUnitViewerType.Chart_Bar) {
        chartDisplayType = 'bar'
    } else if (viewerType == FoundationsEnums.VisualUnitViewerType.Chart_Line) {
        chartDisplayType = 'line'
    } else if (viewerType == FoundationsEnums.VisualUnitViewerType.Chart_StackedBar) {
        chartDisplayType = 'stackedBar'
    } else if (viewerType == FoundationsEnums.VisualUnitViewerType.Chart_ColumnGroup) {
        chartDisplayType = 'columnGroup'
    } else if (viewerType == FoundationsEnums.VisualUnitViewerType.Chart_Scatter) {
        chartDisplayType = 'scatter'
    } else if (viewerType == FoundationsEnums.VisualUnitViewerType.Chart_StackedColumn) {
        chartDisplayType = 'stackedColumn'
    } else if (viewerType == FoundationsEnums.VisualUnitViewerType.Table) {
        chartDisplayType = 'table'
    }
    return chartDisplayType
}

export const getViewerTypeDisplay =  (viewerType: number) => {
    if ((viewerType == FoundationsEnums.VisualUnitViewerType.Unknown) ||
        (viewerType == FoundationsEnums.VisualUnitViewerType.Table)) {
        return "Table";
    } else if (viewerType == FoundationsEnums.VisualUnitViewerType.ActivePanel) {
        return "ActivePanel";
    } else if (viewerType == FoundationsEnums.VisualUnitViewerType.SVU) {
        return "Summary";
    }
    else if (viewerType == FoundationsEnums.VisualUnitViewerType.WorkList) {
        return "ActionList";
    }
    else {
        return "Chart";
    }
}

export const valueFormatter = function (objy: number, objmeasureDataType: any) {
    const valuetoformat = objy
    const measuredatatype = objmeasureDataType.toString() //(obj.measureDataType) ? obj.measureDataType.toString() : '';
    let formattedvalue
    switch (measuredatatype) {
        case FoundationsEnums.HLDataType.HLMoney:
            formattedvalue = '$' + Highcharts.numberFormat(valuetoformat, 0, '.', ',')
            break
        case FoundationsEnums.HLDataType.HLNumber:
        case FoundationsEnums.HLDataType.HLCount:
            formattedvalue = Highcharts.numberFormat(valuetoformat, 0, '.', ',')
            break
        case FoundationsEnums.HLDataType.HLDecimal:
            formattedvalue = Highcharts.numberFormat(
                valuetoformat,
                valuetoformat == 0 || valuetoformat > 100 ? 0 : 2,
                '.',
                ''
            )
            break
        case FoundationsEnums.HLDataType.HLDuration:
            formattedvalue = getDurationDisplayFromHours(valuetoformat)
            break
        case FoundationsEnums.HLDataType.HLPercentage:
            formattedvalue = Highcharts.numberFormat(valuetoformat * 100, 1, '.', '') + '%'
            break
        case FoundationsEnums.HLDataType.HLAgeDays:
            formattedvalue = getAgeDisplayfromDays(valuetoformat)
            break
        default:
            formattedvalue = valuetoformat.toString()
            break
    }
    return formattedvalue
}
export const givemecolor = function (colorinputstring: string) {
    switch (colorinputstring) {
        // stat, urgent, asap, routine, non-stat, others, mine
        case 'emergency':
        case 'stat':
            // intense red
            return '#db3321'
        case 'no':
        case 'false':
        case 'rejected':
        case 'not approved':
            // duller red
            return '#CC3F55'
        case 'urgent':
        case 'asap':
        case 'case pending':
        case 'pending':
            // orange
            return '#fab025'
        case 'inpatient':
            // blue
            return '#4572A7'
        case 'others':
        case 'peer':
        case 'waiting':
        case 'on hold':
        case 'case on hold':
            // light grey blue
            return '#769ECB'
        case 'mine':
        case 'yes':
        case 'true':
        case 'approved':
        case 'confirmed':
        case 'case examined':
        case 'complete':
        case 'routine':
            // green
            return '#62ba47'
        case 'ambulatory':
        case 'non-stat':
        case 'outpatient':
            // light green
            return '#56ba47'
        case 'unknown':
            return '#5E5E5E'
        default:
            // gray
            // return "#4E4E4E";
            break
    }

    return ''
}
export const getCustomColorSeries = function (dimensionName: string) {
    if (dimensionName != null) {
        return givemecolor(dimensionName.toLowerCase())
    }

    return undefined
}

export const getCustomColorSeriesForGroupChart = function (
    dimensionName: string,
    dataSeriesName: string | null
) {
    let colorinputstring = ''
    if (dataSeriesName != null) {
        // give priority to dataseries name for color coding
        colorinputstring = dataSeriesName.toLowerCase()
    } else {
        colorinputstring = dimensionName.toLowerCase()
    }
    const color = givemecolor(colorinputstring)
    return color
}
export const getChartTitle = function (
    formatter: { series?: { name: any } },
    vuChartData: { legendTitle: string },
    vuChartVariationType: any
) {
    switch (vuChartVariationType) {
        case 'C_1M_1X_or_1Y':
            break
        case 'C_1M_1X_and_1Y':
        case 'C_1M_2X_or_2Y':
        case 'C_1M_2X_and_2Y':
        case 'C_1M_2X_and_1Y':
        case 'C_1M_1X_and_2Y':
            return (
                vuChartData.legendTitle +
                ': <strong>' +
                replaceColumnGroupDimensionValue(formatter.series?.name) +
                '</strong><br/>'
            )
    }
    return ''
}

export const percentageChangePerBar = function (
    dataSeries: { [s: string]: any },
    chartOptions: { [s: string]: any },
    vuChartSettings: { [s: string]: any },
    index_i: number
) {
    const arrfirst = dataSeries.data
    var first = arrfirst[0]

    chartOptions.series[index_i].dataLabels = {}
    chartOptions.series[index_i].dataLabels.enabled = true
    chartOptions.series[index_i].dataLabels.inside = true
    chartOptions.series[index_i].dataLabels.color = 'black'
    chartOptions.series[index_i].dataLabels.style = {
        textOutline: '1px contrast',
        'stroke-width': 0,
    }
    chartOptions.series[index_i].dataLabels.formatter = function () {
        this.measureDataType = dataSeries.measuretype
        if (vuChartSettings.ShowChartZeroValue == false) {
            if (this.y > 0) {
                if (vuChartSettings.showPercentageTrend) {
                    var persum = (this.y / first) * 100

                    return valueFormatter(Math.round(persum), dataSeries.measuretype) + ' %'
                } else if (vuChartSettings.ShowChartDataLabel) {
                    return valueFormatter(this.y, dataSeries.measuretype)
                }
            }
        } else {
            if (vuChartSettings.showPercentageTrend) {
                var persum = (this.y / first) * 100

                return valueFormatter(Math.round(persum), dataSeries.measuretype) + ' %'
            } else if (vuChartSettings.ShowChartDataLabel) {
                return valueFormatter(this.y, dataSeries.measuretype)
            }
        }
    }
}
export const percentageTrend = function (
    dataSeries: { [s: string]: any },
    chartOptions: { [s: string]: any },
    ShowChartZeroValue: boolean,
    index_i: number
) {
    chartOptions.series[index_i].type = 'line'
    //if (vuChartSettings.ShowChartDataLabel == false) {  // Check what flag is this
    chartOptions.series[index_i].dataLabels = {}
    chartOptions.series[index_i].dataLabels.enabled = true
    chartOptions.series[index_i].dataLabels.inside = true
    chartOptions.series[index_i].dataLabels.formatter = function () {
        this.measureDataType = dataSeries.measuretype
        if (this.series.processedYData[0] == 0) {
            var i = 0
            do {
                i++
            } while (this.series.processedYData[i] != 0)
            var firstVal = this.series.processedYData[i]
        } else {
            var firstVal = this.series.processedYData[0]
        }

        if (ShowChartZeroValue == false) {
            if (this.y > 0) {
                return Math.round((this.y / firstVal) * 100).toLocaleString() + ' %'
            } else if (this.y == 0) {
                return 'Null Value'
            }
        } else {
            return Math.round((this.y / firstVal) * 100).toLocaleString() + ' %'
        }
    }
}
export const getSeriesName = (series: { color: string; name: any }) => {
    return (
        '<span style="color:' +
        series.color +
        ';">' +
        replaceColumnGroupDimensionValue(series.name) +
        '</span>'
    )
}
export const getSeriesFormattedDisplayValue = (
    formatter: { [s: string]: any },
    point: { series: any; y: any },
    dataTypeStr: any,
    includeBreak: boolean
) => {
    var labelVal = ''
    var breakStr = includeBreak ? '<br/>' : ''

    var percStr = ''
    if (formatter.series.percentage != undefined) {
        percStr = ' (' + Math.round(formatter.series.percentage) + '%)'
    }

    labelVal +=
        breakStr +
        getSeriesName(point.series) +
        ': <strong>' +
        valueFormatter(point.y, dataTypeStr) +
        percStr +
        '</strong>'

    return labelVal
}
export const getMultipleMeasureTooltip = function (
    formatter: { [s: string]: any },
    vuChartData: { xAxis: { title: string } },
    dataTypeStrArray: any[]
) {
    let labelVal = vuChartData.xAxis.title + ': <strong>' + formatter.x + '</strong>'
    const pointIndex = formatter.point.index
    formatter.series.chart?.series.forEach(function (series: { [s: string]: any }, i: number) {
        const point = series.points[pointIndex]
        labelVal += getSeriesFormattedDisplayValue(formatter, point, dataTypeStrArray[i], true)
    })
    return labelVal
}

export const getPieLegendTitle = function (vuChartData: { [s: string]: any }) {
    return vuChartData.legendTitle != '' ? vuChartData.legendTitle : vuChartData.xAxis.title
}

// series.chart.series[0].points

// const applyPieSeriesTitle = function (
//     width: number,
//     name: string | any[],
//     seriesIndex: number,
//     twoPies: any,
//     threePies: any
// ) {
//     var textX = threePies
//         ? (width / 4) * (seriesIndex + 1) + 10 - name.length * 2
//         : twoPies
//           ? (width / 3) * (seriesIndex + 1) + 15 - name.length * 2
//           : width / 2
//     var textY = threePies ? (seriesIndex == 1 ? '20' : '190') : '20'

//     return {
//         html: name,
//         className: 'pie-chart-title',
//         style: {
//             left: textX + 'px',
//             top: textY + 'px',
//         },
//     }
// }

// TODO this code needs to be simiplied, there is not reason for the pie chart case to be so complicated

export const drillThruAllowed = function (
    measureIndex: string | number | undefined,
    AllowDrillThru: string,
    MeasureList: { [s: string]: any },
    userTypeId:string
) {
    let featureList: string[] = []
    window.healthLevelGlobal.getFeatureSecurityList().done(function (successVal: any) {
        featureList = successVal
    })
    if (featureList && featureList.indexOf('AllowDrillThruLaunch') === -1) {
        return false
    }
    if (AllowDrillThru == 'N') return false
    if (measureIndex != undefined && measureIndex < MeasureList.length) {
        if (MeasureList[measureIndex].MetaData.DrillThruType) return true
        else return false
    }
    if (userTypeId == 'SimpleUser') {
        return isOperationAllowed(userTypeId, 'AllowDrillThruLaunch')
    }
    return true
}

// TODO !! handle this once at the top level of react
export const getFeatureSecurityList = (
    myResolve: (arg0: any) => void,
    myReject: (arg0: any) => void
) => {
    if (window.healthLevelGlobal.featureSecurityList == null) {
        FoundationsRequest('GET', {
            url: getBaseUrl() + 'API/v3/Account/GetACL',
            cache: false,
            includeTokenHeader:true,
            success: function (response: { data: any }) {
                window.healthLevelGlobal.featureSecurityList = response.data
                myResolve(response.data)
            },
            error: function (request: any, err: any) {
                // $('#app_page_loading').hide()
                window.healthLevelGlobal.handleAjaxPopupError(request, err)
                myReject(err)
            },
        })
    } else {
        myResolve(window.healthLevelGlobal.featureSecurityList)
    }
}

export const removeTildeChar = (value: string) => {
    const regEx = new RegExp('([0-9]*)~(.*)')
    const matches = regEx.exec(value)
    if (matches != null) {
        return matches[2]
    }
    return value
}

export const removeTildeCharOnly = (value: string) => {
    const regEx = new RegExp('([^0-9.]*)([0-9]*)~(.*)')
    const matches = regEx.exec(value)
    if (matches != null) {
        return matches[1] + matches[3]
    }
    return value
}

export const getColumnGroupCoreDimensionValue = (value: string) => {
    const regEx = new RegExp('(.*)_##_(.*)_##_')
    const matches = regEx.exec(value)
    if (matches != null) {
        return matches[1]
    }
    return value
}

export const findDrillThruMeasureIdForChart = (
    vuId: number,
    seriesName: string,
    MeasureList?: any[]
) => {
    let measureId = -1

    if (MeasureList !== undefined) {
        MeasureList.forEach((measure_value) => {
            const tempName =
                (measure_value.AggregateFunctionName == 'None'
                    ? ''
                    : measure_value.AggregateFunctionName + ' ') + measure_value.MetaData.FieldName
            if (seriesName == tempName) {
                measureId = measure_value.MetaDataId
                return false
            }
        })
    }
    return measureId
}

export const findDrillThruDataPointForChart = (
    vuId: number,
    seriesName: string,
    categoryName: string,
    drillThruDPList?: { [s: string]: any }[],
    MeasureList?: { [s: string]: any }[]
) => {
    let drillThruDPObj: { [s: string]: any } = {}
    if (drillThruDPList != undefined && drillThruDPList != null) {
        if (MeasureList !== undefined && MeasureList.length == 1) {
            // For single measure
            drillThruDPList.forEach(function (value) {
                if (value.dimDPs.length == 1) {
                    let d0 = removeTildeChar(value.dimDPs[0].val)
                    if (d0 == seriesName || d0 == categoryName) {
                        drillThruDPObj = value
                        return false
                    }
                } else if (value.dimDPs.length == 2 || value.dimDPs.length == 3) {
                    let d0 = value.dimDPs[0].val
                    let d1 = value.dimDPs[1].val
                    d0 = removeTildeChar(d0)
                    d1 = removeTildeChar(d1)
                    if (
                        (d0 == seriesName && d1 == categoryName) ||
                        (d1 == seriesName && d0 == categoryName)
                    ) {
                        drillThruDPObj = value
                        return false
                    }
                }
            })
        } else {
            {
                const measureId = findDrillThruMeasureIdForChart(vuId, seriesName, MeasureList)
                drillThruDPList.forEach(function (value) {
                    if (value.meId == measureId && value.dimDPs[0].val == categoryName) {
                        drillThruDPObj = value
                        return false
                    }
                })
            }
        }
    }

    if (drillThruDPObj != null) {
        let newObj = JSON.parse(JSON.stringify(drillThruDPObj))
        // Need to deep copy as objects are passed byref
        newObj.dimDPs.forEach(function (dimDP: { val: string }) {
            dimDP.val = getColumnGroupCoreDimensionValue(dimDP.val)
        })
        return newObj
    } else {
        return drillThruDPObj
    }
}

export const replaceColumnGroupDimensionValue = (value: string) => {
    const regEx = new RegExp('(.*)_##_(.*)_##_')
    const matches = regEx.exec(value)
    if (matches != null) {
        return matches[1] + ' (' + matches[2] + ')'
    }
    return value
}

export const padNumber = (number:number, length:number) => {
    let str = '' + number;
    while (str.length < length) {
        str = '0' + str;
    }
    return parseInt(str);
}

export const getDurationDisplayFromSecs = (seconds:number, forceFormatForDuration:boolean=false)=> { 
    seconds = Math.floor(seconds);
    const negative = (seconds < 0 ? true : false);
    if (negative) seconds = seconds * -1;
    const numInDays = Math.floor(seconds / 86400);
    let hours = Math.floor((seconds % 86400) / 3600);
    let mins = padNumber(Math.floor(((seconds % 86400) % 3600) / 60), 2);
    const sec = padNumber(seconds % 60, 2);
    if (mins == 60) {
        mins = padNumber(0, 2);
        hours = hours + 1;
        hours = padNumber(hours, 2);
    }
    if (seconds == 0) {
        return "0s";
    }
    else if (numInDays > 0 && !forceFormatForDuration) {
        if (numInDays < 3)
            return (negative ? "- " : "") + (numInDays + "d:") + hours + "h";
        else
            return (negative ? "- " : "") + (numInDays + "d");
    }
    else if (forceFormatForDuration == true) {
        return (negative ? "- " : "") + (numInDays + "d:") + hours + "h:" + mins + "m:" + sec + "s";
    }
    else if (hours > 0) {
        return (negative ? "- " : "") + hours + "h:" + mins + "m";
    }
    else
        return (negative ? "- " : "") + mins + "m:" + sec + "s";
}

export const getDurationDisplayFromHours = (hours:number) => {
    return getDurationDisplayFromSecs(hours * 3600.0);
}

export const getAgeDisplayfromDays = (valuetoformat:number)=> {
    if (valuetoformat < 365)
        if (valuetoformat > 30)
            return ((valuetoformat / 12).toString() + " mths");
        else // less than 30 days
            return (valuetoformat.toString() + " days");
    return (valuetoformat / 365).toString() + 'years'; // years
}